// extracted by mini-css-extract-plugin
module.exports = {"row":"TradesPerExchangeDonut_row_1U3lH","relative":"TradesPerExchangeDonut_relative_kf_Hn"};